import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OrderModel } from '../../../models/order.model';
import { OrderCountModel } from '../../../models/order-count.model';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModalModule, PoPageModule, PoButtonModule, PoContainerModule, PoFieldModule, PoTableModule, PoWidgetModule, PoLoadingModule, PoRadioModule, PoModalAction, PoModalComponent, PoInputComponent, PoTableColumnSort, PoSwitchModule, PoSwitchLabelPosition } from '@po-ui/ng-components';
import { ScannerComponent } from '../../../shared/components/scanner/scanner.component';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { CountService } from '../../../shared/service/count.service';
import { ToasterService } from '../../../shared/service/toaster.service';
import { TokenService } from '../../../shared/service/token.service';
import { ProductModel } from '../../../models/product.model';
import { AudioService } from '../../../shared/service/audio.service';
import { disableKeyboardInput } from '../../../shared/components/utils';
@Component({
  selector: 'app-order-count-detail',
  standalone: true,
  imports: [
    PoModalModule,
    CommonModule,
    PoPageModule,
    PoButtonModule,
    PoContainerModule,
    PoFieldModule,
    PoTableModule,
    PoWidgetModule,
    FormsModule,
    ReactiveFormsModule,
    PoLoadingModule,
    PoRadioModule,
    PoSwitchModule,
    ScannerComponent],
  templateUrl: './order-count-detail.component.html',
  styleUrl: './order-count-detail.component.css'
})
export class OrderCountDetailComponent implements AfterViewInit {
  @Input() terminalSelected!: string;
  @Input() orderModel!: OrderModel;
  @Input() orderCountModel!: OrderCountModel;
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() onCountFinished = new EventEmitter();

  @ViewChild('poModalListItens', { static: false }) poModalListItens!: PoModalComponent;
  @ViewChild('countCard') countCardDiv!: ElementRef<HTMLDivElement>;
  @ViewChild('scanner') scanner!: ScannerComponent;

  locationItem: string = '';
  itemSelectLocation: string = 'TODAS';
  selectLocation: any = [];
  labelPosition: PoSwitchLabelPosition = PoSwitchLabelPosition.Left;
  listModalLocation: any = [];
  listModalLocationWithTotals: any = [];
  countedItemsColumns: any;
  listAllItems: any = [];
  listItems: any = [];
  productCodeInput: string = '';
  selectedMode: boolean = false;
  currentProduct: any;
  productIndex: number = 0;
  hasNext = true;
  hasPrevious = false;
  productTotalizer = '1/?';
  seeDescriptionItens: boolean = false;
  quantityValue: string = '1';
  countInProgress: number = 1;

  // secondaryActionBarCodeReader removido, não é mais utilizado

  constructor(
    private toasterService: ToasterService,
    private router: Router,
    private tokenService: TokenService,
    private countService: CountService,
    private audioService: AudioService) { }

  ngAfterViewInit(): void {
    this.loading(true);
    this.getOrderCountItems();
  }

  scrollToInPageProductInput() {
    const wrapper = document.querySelector('.po-page-content');

    if (wrapper && this.countCardDiv) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const divRect = this.countCardDiv.nativeElement.getBoundingClientRect();

      const offsetTop = divRect.top - wrapperRect.top + wrapper.scrollTop;

      setTimeout(() => {
        wrapper.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });

        this.loading(false);
      }, 500);
    } else {
      this.loading(false);
    }
  }

  loading(value: boolean) {
    this.isLoading.emit(value);
  }

  disableKeyboard() {
    const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
    disableKeyboardInput(input);
  }

  countInReadOnly() {
    return this.orderCountModel.countStatus.value != this.countInProgress;
  }

  getOrderCountItems() {
    this.hasPrevious = false;
    this.hasNext = false;
    this.countService.getOrderItemsCount(this.orderModel.orderBranchCode, this.orderModel.orderCode, this.orderCountModel.countCode).subscribe(({
      next: (data: any) => {
        this.listItems = data.items;

        if (data.items.length == 0)
          return;

        this.productTotalizer = `1/${data.items.length}`;

        this.locationItem = data.items[0].localDescription || 'Localização não informada';

        if (data.items.length > 1) {
          this.hasNext = true;
        }

        this.currentProduct = data.items[0];
        this.productIndex == 0;
        this.scrollToInPageProductInput();
      },
      error: (error: any) => {
        const errorMessage = error?.error?.[0]?.message ?? 'Não foi possível obter os itens da contagem';
        this.toasterService.triggerAlert(errorMessage, 'error');
        this.scrollToInPageProductInput();
      }
    }));
  }

  recoverLocationSelected(event: any) {
    this.countedItemsColumns = [
      { property: 'COD', label: 'COD', type: 'string' },
      { property: 'DES', label: 'DES', type: 'string' },
      { property: 'QTD S', label: 'QTD S', type: 'number' },
      { property: 'QTD C', label: 'QTD C', type: 'number' },
      { property: 'QTD P', label: 'QTD P', type: 'number' }
    ];
    if (event === 'TODAS') {
      this.listModalLocation = this.listAllItems;
    } else {
      const eventSame = this.listItems.filter((item: any) => {
        return item.localDescription === event
      })
      this.listModalLocation = eventSame.map((item: any) => ({
        'COD': item.productCode.toString(),
        'DES': item.productDescription,
        'QTD S': item.orderQuantity,
        'QTD C': item.countQuantity,
        'QTD P': item.pendingQuantity,
        isTotal: false
      }));
    }

    this.updateListWithTotals();
  }

  updateListWithTotals() {
    const totalRow = {
      'COD': 'Total',
      'DES': '',
      'QTD S': this.listModalLocation.reduce((sum: number, i: { [x: string]: any; }) => sum + Number(i['QTD S'] || 0), 0),
      'QTD C': this.listModalLocation.reduce((sum: number, i: { [x: string]: any; }) => sum + Number(i['QTD C'] || 0), 0),
      'QTD P': this.listModalLocation.reduce((sum: number, i: { [x: string]: any; }) => sum + Number(i['QTD P'] || 0), 0),
      isTotal: true
    };

    this.listModalLocationWithTotals = [...this.listModalLocation, totalRow];
  }

  onSortChange(sort: any) {
    const column = sort.column;
    const type = sort.type;
    const direction = type === 'ascending' ? 1 : -1;

    if (!column?.property) {
      return;
    }

    const property = column.property;

    this.listModalLocation.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valA = a[property];
      const valB = b[property];

      if (typeof valA === 'number' && typeof valB === 'number') {
        return (valA - valB) * direction;
      }

      return String(valA).localeCompare(String(valB)) * direction;
    });

    this.updateListWithTotals();
  }

  onReadBarcodeReader(event: any) {
    this.productCodeInput = event;
    !this.selectedMode
      ? this.addProduct()
      : this.recoverProductDeleteProduct()
  }

  onScan(event: string) {
    this.productCodeInput = event;
    !this.selectedMode
      ? this.addProduct()
      : this.recoverProductDeleteProduct()
  }

  addProduct() {
    this.recoverProduct().pipe(
      catchError((error) => {
        const errorMessage = error?.error?.[0]?.message ?? `Produto ${this.productCodeInput} não encontrado`;
        this.toasterService.triggerAlert(errorMessage, 'error');
        this.productCodeInput = '';
        return of(null);
      })
    ).subscribe((data) => {
      this.loading(false);
      if (data !== null && data.items.length > 0) {
        this.countProduct(data.items[0]);
      }
    });
  }

  recoverProductDeleteProduct() {
    this.recoverProduct().pipe(
      catchError((err) => {
        this.loading(false);
        const errorMessage = err?.error?.[0]?.message ?? `Não foi possível localizar o produto ${this.productCodeInput} para exclusão`;
        this.toasterService.triggerAlert(errorMessage, 'error');
        this.productCodeInput = '';
        return of(null);
      })
    ).subscribe((data) => {
      if (data !== null) {
        this.deleteProduct(data.items[0].productCode, data.items[0].isRfid ? this.productCodeInput : "");
      }
    });
  }

  delete(productCode: number, rfid: string) {
    return this.countService.deleteProductItensCount(this.orderModel.orderBranchCode, this.orderCountModel.countCode, [{ productCode, rfid }]);
  }

  deleteProduct(productCode: number, productSku: string) {
    this.delete(productCode, productSku).subscribe({
      next: (data) => {
        this.loading(false);
        if (data !== null) {
          this.updateList(productCode);
          this.audioService.playBeep(1);
          this.toasterService.triggerAlert(
            'Produto ' + this.productCodeInput + ' excluído com sucesso',
            'success'
          );
          this.productCodeInput = '';
        }
      }, error: (err) => {
        this.loading(false);
        const errorMessage = err?.error?.[0]?.message ?? `Não foi possível excluir o produto ${this.productCodeInput}`;
        this.toasterService.triggerAlert(errorMessage, 'error');
        this.productCodeInput = '';
      }
    })
  }

  recoverProduct() {
    return this.countService.getProduct(this.productCodeInput, this.orderModel.orderBranchCode);
  }

  countProduct(product: ProductModel) {
    this.recoverCountProduct(product)
      .subscribe({
        next: (data) => {
          this.productCodeInput = '';
          var countProduct = data.items[0];
          this.audioService.playBeep(1);
          this.updateList(countProduct.productCode, countProduct.countQuantity, countProduct.pendingQuantity, countProduct.overCountQuantity);
        },
        error: (error: any) => {
          const errorMessage = error?.error?.[0]?.message ?? `Não foi possível contar o produto ${this.productCodeInput}`;
          this.toasterService.triggerAlert(errorMessage, 'error');
          this.productCodeInput = '';
          return of(false);
        }
      });
  }

  recoverCountProduct(product: ProductModel) {
    const countItemProduct = this.listItems.find((ob: any) => ob.productCode === product.productCode);
    const pendingQuantity = countItemProduct?.pendingQuantity ?? 0;
    const orderQuantity = countItemProduct?.orderQuantity ?? 0;
    const overCountQuantity = countItemProduct?.overCountQuantity ?? 0;

    return this.countService.postProductItensCount(
      this.orderModel.orderBranchCode,
      Number(this.terminalSelected),
      this.orderModel.orderBranchCode,
      this.orderCountModel.countCode,
      product.productCode,
      1,
      pendingQuantity,
      overCountQuantity,
      this.orderModel.orderCode,
      orderQuantity,
      product.isRfid ? this.productCodeInput : product.productSku,
      product.isRfid ? this.productCodeInput : null
    );
  }

  updateList(productCode: number, countQuantity: number = 0, pendingQuantity: number = 0, overCountQuantity: number = 0) {
    let item = this.listItems.find((item: any) => item.productCode == productCode);

    if (!item) return;

    if (!this.selectedMode) {
      item.overCountQuantity > 0 ? item.countQuantity = item.countQuantity + 1 : item.countQuantity = countQuantity;
      item.overCountQuantity > 0 ? item.overCountQuantity = item.overCountQuantity + 1 : item.overCountQuantity = overCountQuantity;
      item.pendingQuantity = pendingQuantity;
    } else {
      item.countQuantity = this.currentProduct.countQuantity - 1;
      this.currentProduct.countQuantity < this.currentProduct.orderQuantity ? item.overCountQuantity = 0 : item.overCountQuantity = this.currentProduct.overCountQuantity - 1;
      this.currentProduct.countQuantity > this.currentProduct.orderQuantity ? item.pendingQuantity = 0 : item.pendingQuantity = this.currentProduct.orderQuantity - this.currentProduct.countQuantity;
    }

    this.selectedMode = false;

    if (item.productCode !== this.currentProduct.productCode) {
      this.onItemsListSelected(item.productCode);
    }

    this.advanceToNextLocationIfNeeded();

  }

  private isLocationComplete(location: string): boolean {
    const itemsInLocation = this.listItems.filter((i: any) => (i.localDescription || '') === (location || ''));
    if (!itemsInLocation || itemsInLocation.length === 0) return false;

    return itemsInLocation.every((i: any) => {
      const orderQty = Number(i.orderQuantity || 0);
      const counted = Number(i.countQuantity || 0);
      const pending = Number(i.pendingQuantity || 0);
      return pending <= 0 || counted >= orderQty;
    });
  }

  private advanceToNextLocationIfNeeded(): void {
    if (!this.currentProduct) return;

    const currentLocation = this.currentProduct.localDescription || '';

    if (!currentLocation) return;

    if (!this.isLocationComplete(currentLocation)) return;

    let nextIndex = -1;
    for (let i = this.productIndex + 1; i < this.listItems.length; i++) {
      const loc = this.listItems[i].localDescription || '';
      if (loc !== currentLocation) {
        const firstOfNext = this.listItems.findIndex((it: any, idx: number) => (it.localDescription || '') === loc && idx >= i);
        nextIndex = firstOfNext;
        break;
      }
    }

    if (nextIndex !== -1 && nextIndex !== this.productIndex) {
      this.productIndex = nextIndex;
      this.updateCurrentItemState();
      setTimeout(() => {
        const input = document.querySelector('input[name="inputBarcode"]') as HTMLInputElement;
        if (input) input.focus();
      }, 0);
    }
  }

  onItemsListSelected(event: number) {
    let itemIndex = this.listItems.findIndex((item: any) => item.productCode == event);

    if (itemIndex !== -1) {
      this.currentProduct = this.listItems[itemIndex];
      this.productIndex = itemIndex;
      this.updateCurrentItemState();
    }
  }

  nextItem() {
    this.productIndex++;
    this.updateCurrentItemState();
    setTimeout(() => {
      const input = document.querySelector('input[name="inputBarcode"]') as HTMLInputElement;
      if (input) input.focus();
    }, 0);
  }

  previousItem() {
    this.productIndex--;
    this.updateCurrentItemState();
    setTimeout(() => {
      const input = document.querySelector('input[name="inputBarcode"]') as HTMLInputElement;
      if (input) input.focus();
    }, 0);
  }

  updateCurrentItemState(): void {
    this.currentProduct = this.listItems[this.productIndex];
    this.hasPrevious = this.productIndex > 0;
    this.hasNext = this.productIndex < this.listItems.length - 1;
    this.setProductTotalizer(this.productIndex + 1);
  }

  setProductTotalizer(count: number) {
    if (count < 1)
      count = 1;
    this.productTotalizer = `${count}/${this.listItems.length}`;
  }

  onModeChange(value: boolean) {
    this.selectedMode = value;
  }

  onCountProductCode() {
    if (this.countInReadOnly()) return;
    this.loading(true);
    if (this.productCodeInput.trim() == '') {
      this.productCodeInput = '';
      this.loading(false);
      return;
    }
    !this.selectedMode
      ? this.addProduct()
      : this.recoverProductDeleteProduct()
  }

  openItemsModal() {
    const locationRecover: any = [];
    this.selectLocation = [{ label: 'TODAS', value: 'TODAS' }];
    this.listItems.map((location: any) => locationRecover.push(location.localDescription));
    const removeDuplicite = locationRecover.filter((value: any, index: any, self: any) => {
      return self.indexOf(value) === index;
    });
    removeDuplicite.map((item: any) =>
      this.selectLocation.push({
        label: item,
        value: item,
      }
      ));

    this.listAllItems = this.listItems.map((item: any) => ({
      'COD': item.productCode.toString(),
      'DES': item.productDescription,
      'QTD S': item.orderQuantity,
      'QTD C': item.countQuantity,
      'QTD P': item.pendingQuantity,
      isTotal: false
    }));

    this.listModalLocation = this.listAllItems;

    this.updateListWithTotals();

    this.poModalListItens.open();
  }

  save() {
    if (this.countInReadOnly()) return;
    this.finalize().pipe(
      catchError((error) => {
        const errorMessage = error?.error?.[0]?.message ?? 'Não foi possível finalizar a contagem';
        this.toasterService.triggerAlert(errorMessage, 'error');
        return of(null);
      })
    ).subscribe((data: any) => {
      if (data !== null) {
        this.toasterService.triggerAlert('Contagem finalizada com sucesso', 'success');
        this.onCountFinished.emit();
        setTimeout(() => {
          this.router.navigate(['/count']);
        }, 2000);
      }
    });
  }

  seeDescription() {
    this.seeDescriptionItens = !this.seeDescriptionItens;
  }

  finalize() {
    return this.countService.postFinalizeSalesOrderCount(
      this.orderModel.orderBranchCode,
      this.orderCountModel.countCode,
      Number(this.tokenService.getBranch()),
      this.orderModel.orderCode
    )
  }
}
